import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const STATUSES = ["En cours d'examen", "Accepté", "Refusé"];

export default function SubscriptionRequests() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");

  const load = () => api.get("/subscription-requests").then((r) => setItems(r.data)).catch((e) => setError(formatApiError(e)));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    setBusy(id);
    try {
      await api.post(`/subscription-requests/${id}/status`, { status, comment: "" });
      load();
    } catch (e) { setError(formatApiError(e)); }
    finally { setBusy(""); }
  };

  return (
    <div data-testid="subscriptions-admin">
      <div className="eyebrow eyebrow-dark">Bibliothèque numérique</div>
      <h1 className="mt-2 text-3xl font-bold text-unisic-blue">Demandes d'abonnement</h1>
      <p className="mt-2 text-slate-600 text-sm">Traitez les demandes d'accès aux contenus réservés.</p>
      <span className="divider-gold mt-3" />

      {error && <div className="mt-4 text-sm text-unisic-red">{error}</div>}

      <div className="mt-8 paper-card overflow-hidden">
        <table className="unisic-table w-full">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="px-4 py-3">Demandeur</th>
              <th className="px-4 py-3">Publication</th>
              <th className="px-4 py-3">Affiliation</th>
              <th className="px-4 py-3">Statut</th>
              <th className="px-4 py-3">Reçu</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id} className="hover:bg-slate-50" data-testid={`sub-row-${r.id}`}>
                <td className="px-4 py-3">
                  <div className="font-medium text-unisic-blue">{r.full_name}</div>
                  <div className="text-xs text-slate-500">{r.email}</div>
                  {r.phone && <div className="text-xs text-slate-500">{r.phone}</div>}
                </td>
                <td className="px-4 py-3 text-sm max-w-xs truncate">{r.publication_title || "—"}</td>
                <td className="px-4 py-3 text-sm">{r.affiliation || "—"}</td>
                <td className="px-4 py-3">
                  <select value={r.status} disabled={busy === r.id} onChange={(e) => setStatus(r.id, e.target.value)} className="text-xs border border-slate-300 px-2 py-1 rounded-sm bg-white" data-testid={`sub-status-${r.id}`}>
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3 text-xs text-slate-500">{r.created_at ? new Date(r.created_at).toLocaleDateString("fr-FR") : ""}</td>
                <td className="px-4 py-3 text-right">
                  {r.reason && <div className="text-xs text-slate-500 italic max-w-xs truncate">« {r.reason} »</div>}
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={6} className="text-center py-10 text-slate-500">Aucune demande pour l'instant.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
